module.exports = __webpack_public_path__ + "media/images/star-on-533b6fe98e1c2305a6688f51ebf69e3d.png";